import { Container, Row, Col, Card } from "react-bootstrap";
import "./Services.css";
import OurServices from "./OurServices";
function Services() {
  const services = [
    {
      title: "The Initial Planning",
      description:
        "Initial building planning covers the structured process of designing and preparing for construction—from identifying the need to creating ready-to-start documentation.",
      img: require("../../../assets/Step1.png"),
    },
    {
      title: "Architectural & Vastu Plan",
      description:
        "A well-balanced floor plan showing layout, dimensions, and design harmony, blending architectural excellence with Vastu principles for comfort and energy flow.",
      img: require("../../../assets/step2.png"),
    },
    {
      title: "Permission Drawing",
      description:
        "To obtain building permission in Assam, you must follow a structured process managed by GMDA, GMC, ULBs, or Panchayats. As we are also ERTP, we can provide Building Permission up to G+2 in just 7 to 10 working days.",
      img: require("../../../assets/step3.png"),
    },
    {
      title: "Structural Drawing",
      description:
        "To obtain building permission in Assam, you must follow a structured process managed by GMDA, GMC, ULBs, or Panchayats. As we are also ERTP, we can provide Building Permission up to G+2 in just 7 to 10 working days.",

      img: require("../../../assets/step4.png"),
    },
    {
      title: "3D & 2D Exterior & Interior Design",
      description:
        "We create 3D visualizations for both interior and exterior designs, along with precise 2D layouts for accurate project execution.",
      img: require("../../../assets/step5.png"),
    },
    {
      title: "Plan & Estimate",
      description:
        "We provide detailed cost estimates and documentation for loan approvals and project planning in quick time.",
      img: require("../../../assets/step6.png"),
    },
    {
      title: "Detailed Project Report (DPR)",
      description:
        "We deliver complete DPRs covering technical, financial, and operational details — ensuring a clear project roadmap.",
      img: require("../../../assets/step8.png"),
    },
    {
      title: "Supervision & Project Management",
      description:
        "Our team provides complete site supervision and project management sercies to ensure timely execution, quality control, const efficiency, and adherence to safety standards.",
      img: require("../../../assets/step9.png"),
    },
    {
      title: "Progress Update via our Website",
      description:
        "We provide weekly updates on your project through our website. You can easily track the work status, see progress reports, and stay informed about every step without any hassle. This helps you stay updated and connected throughout the entire project.",
      img: require("../../../assets/step7.png"),
    },
  ];
  return (
    <div className="">
      {/*  Services heading*/}

      <div className="flow-container">
        <Row className="construction-flow-row py-5 justify-content-center">
          <div className="construction-flow-heading text-center">
            <div className="our-services-heading-container">
              {/* <h2 className="ourteam-heading">Our Approach</h2> */}
              <h4>Our Approach</h4>

              <h1>How we bring your dreams to life!</h1>

              <p>
                We simplify the construction journey — from concept to
                completion, with clear milestones at every stage.
              </p>
            </div>
          </div>

          {services.map((service, index) => (
            <Col
              key={index}
              xs={12}
              sm={10}
              md={6}
              lg={4}
              className="d-flex justify-content-center mb-4"
            >
              <Card className="service-card text-center">
                <div className="step-number">0{index + 1}</div>
                <div className="service-icon">
                  <img loading="lazy" decoding="async"
                    src={service.img}
                    alt={service.title}
                    className="service-card-image"
                  />
                </div>
                <Card.Body>
                  <Card.Title className="service-title">
                    {service.title}
                  </Card.Title>
                  <Card.Text className="service-description">
                    {service.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default Services;
